import { z } from 'zod';

export enum WorkerStatus {
  ONBOARDED = 'Onboarded',
  ONBOARDING = 'Onboarding',
  NOT_ONBOARDING = 'NotOnboarding',
}

const paymentObjectSchema = z.object({
  workerName: z.string(),
  id: z.string(),
  creationDate: z.string().optional(),
  reference: z.string().optional(),
  status: z.string(),
  dueDate: z.string().optional(),
  invoiceUrl: z.string().nullish(),
  failureReason: z.object({ date: z.string(), reason: z.string() }).optional().nullable(),
});

export const paymentInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(paymentObjectSchema),
});

const paymentUsersObjectSchema = z.object({
  flexWorkerId: z.string(),
  fullName: z.string(),
  iban: z.string().optional(),
  hasPendingBankAccount: z.boolean(),
  status: z.nativeEnum(WorkerStatus),
  isBlocked: z.boolean(),
});

export const paymentUsersInfiniteResponseSchema = z.object({
  totalRows: z.number(),
  nextPage: z.number().optional(),
  previousPage: z.number().optional(),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
  items: z.array(paymentUsersObjectSchema),
});

export type PaymentInfiniteResponse = z.infer<typeof paymentInfiniteResponseSchema>;
export type PaymentUsersInfiniteResponse = z.infer<typeof paymentUsersInfiniteResponseSchema>;
